<template>
  <div>
    <v-card class="elevation-0">
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách sim"
          v-model="table.searchText"
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :search="table.searchText"
          :items="datasource"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.ownerName }}</td>
            <td>
              <span v-if="!props.item.isValid" class="red-text">{{ props.item.iccId }}</span>
              <span v-else>{{ props.item.iccId }}</span>
            </td>
            <td>{{ props.item.phone }}</td>
            <td>{{ props.item.telco }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: 'Nhà cung cấp',
            value: 'ownerName'
          },
          {
            text: 'ICCID',
            value: 'iccId'
          },
          {
            text: 'Số điện thoại',
            value: 'phone'
          },
          {
            text: 'Nhà mạng',
            value: 'telco'
          }
        ]
      }
    };
  }
};
</script>
<style>
.red-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/sim/components/exportlist.vue